import React, { Component } from "react";
import { connect } from "react-redux";
import { showError, showSuccess } from "ReduxErrorBar";
import { sortableHandle } from "react-sortable-hoc";
import ReactConfirmAlert, { confirmAlert } from "react-confirm-alert";
import _ from "lodash";
import {
  ticketAssociatedWithSession,
  deleteTicket,
  editTicket,
  openTicketModal,
  openTicketUrl,
  checkTicketDaschoardStatus,
  openSessionModal,
} from "TicketAction";
import { COMMON_FAIL_MESSAGE, DOMAIN_NAME, DEVELOPMENT_TYPE } from "Constants";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { CopyToClipboard } from "react-copy-to-clipboard";
import LocaleStrings from "Languages";

const DragHandle = sortableHandle(() => (
  <span className="drag-icon" style={{ cursor: "move" }}>
    <i className="fa fa-bars mx-6" aria-hidden="true"></i>
  </span>
));
class TicketListItem extends Component {
  constructor(props) {
    super(props);
    this.viewTicket = this.viewTicket.bind(this);
    this.viewAssociateSession = this.viewAssociateSession.bind(this);
    this.editTicket = this.editTicket.bind(this);
    this.deleteTicket = this.deleteTicket.bind(this);
    this.state = { copied: false };
  }

  viewTicket() {
    this.props.openTicketUrl(true, this.props.ticket.tickecode);
  }

  viewAssociateSession() {
    let { ticket } = this.props;

    this.props.openSessionModal({ showModal: true, data: ticket });
  }

  editTicket() {
    let { ticket, userCategoryList } = this.props;

    var category = _.filter(userCategoryList, (obj) => {
      return obj.id == ticket.usercategory;
    });
    // console.log("category :- ", category);

    this.props.editTicket(ticket);
    this.props.openTicketModal({
      showModal: true,
      genre: ticket.type,
      category: ticket.type === "addon" ? "addon" : category[0].type,
    });
  }

  copyUrl = () => {
    this.setState({ copied: true });

    setTimeout(() => {
      this.setState({ copied: false });
    }, 500);
  };

  deleteTicket() {
    let pageNo = this.props.currentPage;
    if (this.props.pageDataLength == 1) {
      pageNo = pageNo - 1;
    }

    confirmAlert({
      title: LocaleStrings.tickets_ticket_title_delete_ticket,
      message: LocaleStrings.tickets_ticket_text_sure_want_to_delete,
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.props.ticketAssociatedWithSession(
              this.props.session,
              this.props.ticket,
              (res) => {
                if (res && res.success === 1) {
                  this.props.deleteTicket(
                    this.props.session,
                    this.props.ticket,
                    (response) => {
                      if (response.success === 0) {
                        this.props.showError(COMMON_FAIL_MESSAGE);
                      } else if (response.success === 2) {
                        this.props.showError(
                          LocaleStrings.tickets_ticket_text_delete_ticket_error
                        );
                      } else {
                        this.props.checkTicketDaschoardStatus(
                          this.props.session
                        );
                        this.props.showSuccess(
                          LocaleStrings.tickets_ticket_text_delete_ticket_success
                        );
                        this.props.pagination(pageNo);
                      }
                    }
                  );
                } else {
                  var message = `Ticket is associated with ${res.result[0].title} session.`;
                  this.props.showError(message);
                }
              }
            );
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  render() {
    let { eventDetails, settingInfo, sortby, ticket, ticketDashboard } =
      this.props;
    let seocode =
      eventDetails && eventDetails.seocode
        ? eventDetails.seocode
        : "not-found-seocode";
    var ticketUrl = `https://${seocode}.${DOMAIN_NAME}/t/tickets/${this.props.ticket.tickecode}`;
    var totalsoldtickets = this.props.ticket.totalsoldtickets
      ? this.props.ticket.totalsoldtickets
      : 0;

    return sortby ? (
      <div
        className="row"
        style={{
          borderTop: "var(--custom-border)",
          padding: "10px 16px",
        }}
      >
        <div className="col-md-4 col-sm-3">
          <div className="d-flex">
            <DragHandle />
            <div>
              {ticket.ticketname}
              {ticket.tickettype == "paid" &&
              ticketDashboard &&
              !ticketDashboard.paymentgateway ? (
                <OverlayTrigger
                  key={ticket.id}
                  placement="right"
                  overlay={
                    <Tooltip id={`tooltip-${ticket.id}`}>
                      {/* {ticket.ticketdesc} */}
                      {
                        LocaleStrings.tickets_ticket_text_ticket_not_available_for_sale
                      }
                    </Tooltip>
                  }
                >
                  <i
                    className="fa fa-exclamation-circle"
                    style={{ color: "#ff0000", paddingLeft: 10 }}
                  ></i>
                </OverlayTrigger>
              ) : ticket.tickettype == "paid" &&
                ticket.isofflinepayment &&
                settingInfo &&
                settingInfo.resource &&
                settingInfo.resource.length > 0 &&
                !settingInfo.resource[0].stripecustomercardid &&
                !settingInfo.resource[0].stripecustomerid ? (
                <OverlayTrigger
                  key={ticket.id}
                  placement="right"
                  overlay={
                    <Tooltip id={`tooltip-${ticket.id}`}>
                      {/* {ticket.ticketdesc} */}
                      {
                        LocaleStrings.tickets_ticket_text_ticket_not_available_for_offline_payment
                      }
                    </Tooltip>
                  }
                >
                  <i
                    className="fa fa-exclamation-circle"
                    style={{ color: "#ff0000", paddingLeft: 10 }}
                  ></i>
                </OverlayTrigger>
              ) : (
                ""
              )}
              {ticket.status == "disabled" ? (
                <OverlayTrigger
                  key={ticket.id}
                  placement="right"
                  overlay={
                    <Tooltip id={`tooltip-${ticket.id}`}>
                      {/* {ticket.ticketdesc} */}
                      <span className="text-uppercase">
                        {LocaleStrings.disabled}
                      </span>
                    </Tooltip>
                  }
                >
                  <i
                    className="fa fa-triangle-exclamation"
                    style={{ color: "#f30909", paddingLeft: 10 }}
                  ></i>
                </OverlayTrigger>
              ) : ticket.status == "hidden" ? (
                <OverlayTrigger
                  key={ticket.id}
                  placement="right"
                  overlay={
                    <Tooltip id={`tooltip-${ticket.id}`}>
                      {/* {ticket.ticketdesc} */}
                      <span className="text-uppercase">
                        {LocaleStrings.hidden}
                      </span>
                    </Tooltip>
                  }
                >
                  <i
                    className="fa fa-triangle-exclamation"
                    style={{ color: "#f3d713", paddingLeft: 10 }}
                  ></i>
                </OverlayTrigger>
              ) : (
                ""
              )}
              {ticket.type === "addon" ? (
                <div className="ticket-addon-text">
                  {LocaleStrings.tickets_add_ticket_option5}
                </div>
              ) : (
                ""
              )}
              <p className="ticket-description">
                <i>({ticket.ticketdesc})</i>
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-2 col-sm-2">
          {ticket.quantity ? ticket.quantity : LocaleStrings.unlimited}
        </div>
        <div className="col-md-1 col-sm-2">{totalsoldtickets}</div>
        <div className="col-md-1 col-sm-1">
          {ticket.quantity
            ? parseInt(ticket.quantity) - parseInt(totalsoldtickets)
            : LocaleStrings.unlimited}
        </div>
        <div className="col-md-1 col-sm-1">
          {ticket.price > 0 ? ticket.currency + " " + ticket.price : "FREE"}
        </div>
        <div className="col-md-3 col-sm-3">
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="action-button">
              {this.state.copied ? (
                <div className="">
                  <button className="btn btn-custom-table-white">
                    {LocaleStrings.button_copied}
                  </button>
                </div>
              ) : (
                <CopyToClipboard text={ticketUrl} onCopy={this.copyUrl}>
                  <div className="">
                    <button className="btn btn-custom-table-white">
                      {LocaleStrings.button_copy_url}
                    </button>
                  </div>
                </CopyToClipboard>
              )}
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="action-button" style={{ marginLeft: 5 }}>
              <button
                className="btn btn-custom-table-white"
                onClick={this.viewTicket}
              >
                {LocaleStrings.button_view}
              </button>
            </div>
          )}
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.editTicket}
            >
              {LocaleStrings.button_edit}
            </button>
          </div>
          <div className="action-button" style={{ marginLeft: 5 }}>
            {totalsoldtickets == 0 ? (
              <button
                className="i-custom-table-delete"
                onClick={this.deleteTicket}
              >
                {" "}
                X{" "}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    ) : (
      <tr
        style={
          ticket.status == "hidden"
            ? { backgroundColor: "#c5cde133" }
            : ticket.status == "disabled"
            ? { backgroundColor: "#cc5c5c63" }
            : {}
        }
      >
        <td className="first-td">
          {ticket.ticketname}
          {ticket.tickettype == "paid" &&
          ticketDashboard &&
          !ticketDashboard.paymentgateway ? (
            <OverlayTrigger
              key={ticket.id}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${ticket.id}`}>
                  {/* {ticket.ticketdesc} */}
                  {
                    LocaleStrings.tickets_ticket_text_ticket_not_available_for_sale
                  }
                </Tooltip>
              }
            >
              <i
                className="fa fa-exclamation-circle"
                style={{ color: "#ff0000", paddingLeft: 10 }}
              ></i>
            </OverlayTrigger>
          ) : ticket.tickettype == "paid" &&
            ticket.isofflinepayment &&
            settingInfo &&
            settingInfo.resource &&
            settingInfo.resource.length > 0 &&
            !settingInfo.resource[0].stripecustomercardid &&
            !settingInfo.resource[0].stripecustomerid ? (
            <OverlayTrigger
              key={ticket.id}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${ticket.id}`}>
                  {/* {ticket.ticketdesc} */}
                  {
                    LocaleStrings.tickets_ticket_text_ticket_not_available_for_offline_payment
                  }
                </Tooltip>
              }
            >
              <i
                className="fa fa-exclamation-circle"
                style={{ color: "#ff0000", paddingLeft: 10 }}
              ></i>
            </OverlayTrigger>
          ) : (
            ""
          )}
          {ticket.status == "disabled" ? (
            <OverlayTrigger
              key={ticket.id}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${ticket.id}`}>
                  {/* {ticket.ticketdesc} */}
                  <span className="text-uppercase">
                    {LocaleStrings.disabled}
                  </span>
                </Tooltip>
              }
            >
              <i
                className="fa fa-triangle-exclamation"
                style={{ color: "#f30909", paddingLeft: 10 }}
              ></i>
            </OverlayTrigger>
          ) : ticket.status == "hidden" ? (
            <OverlayTrigger
              key={ticket.id}
              placement="right"
              overlay={
                <Tooltip id={`tooltip-${ticket.id}`}>
                  {/* {ticket.ticketdesc} */}
                  <span className="text-uppercase">{LocaleStrings.hidden}</span>
                </Tooltip>
              }
            >
              <i
                className="fa fa-triangle-exclamation"
                style={{ color: "#f3d713", paddingLeft: 10 }}
              ></i>
            </OverlayTrigger>
          ) : (
            ""
          )}
          {ticket.type === "addon" ? (
            <div className="ticket-addon-text">
              {LocaleStrings.tickets_add_ticket_option5}
            </div>
          ) : (
            ""
          )}
          <p className="ticket-description">
            <i>({ticket.ticketdesc})</i>
          </p>
        </td>
        <td className="middle-td">
          {ticket.quantity ? ticket.quantity : LocaleStrings.unlimited}
        </td>
        <td className="middle-td">{totalsoldtickets}</td>
        <td className="middle-td">
          {ticket.quantity
            ? parseInt(ticket.quantity) - parseInt(totalsoldtickets)
            : LocaleStrings.unlimited}
        </td>
        <td className="middle-td">
          {ticket.price > 0 ? ticket.currency + " " + ticket.price : "FREE"}
        </td>
        <td className="last-td" style={{ width: 500 }}>
          {/* {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="action-button">
              <button
                className="btn btn-custom-table-white"
                onClick={this.viewAssociateSession}
              >
                {LocaleStrings.sessions}
              </button>
            </div>
          )} */}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="action-button">
              {this.state.copied ? (
                <div className="">
                  <button className="btn btn-custom-table-white">
                    {LocaleStrings.button_copied}
                  </button>
                </div>
              ) : (
                <CopyToClipboard text={ticketUrl} onCopy={this.copyUrl}>
                  <div className="">
                    <button className="btn btn-custom-table-white">
                      {LocaleStrings.button_copy_url}
                    </button>
                  </div>
                </CopyToClipboard>
              )}
            </div>
          )}
          {DEVELOPMENT_TYPE === "koachify" ? (
            ""
          ) : (
            <div className="action-button" style={{ marginLeft: 5 }}>
              <button
                className="btn btn-custom-table-white"
                onClick={this.viewTicket}
              >
                {LocaleStrings.button_view}
              </button>
            </div>
          )}
          <div className="action-button" style={{ marginLeft: 5 }}>
            <button
              className="btn btn-custom-table-white"
              onClick={this.editTicket}
            >
              {LocaleStrings.button_edit}
            </button>
          </div>
          <div className="action-button" style={{ marginLeft: 5 }}>
            {totalsoldtickets == 0 ? (
              <button
                className="i-custom-table-delete"
                onClick={this.deleteTicket}
              >
                {" "}
                X{" "}
              </button>
            ) : (
              ""
            )}
          </div>
        </td>
      </tr>
    );
  }
}

export var mapStateToProps = (state) => {
  return {
    session: state.session,
    eventDetails: state.userEventDetails,
    ticketDashboard: state.ticketDashboard.data,
    userCategoryList: state.userCategoryList.data,
    settingInfo: state.SettingData,
  };
};

export default connect(mapStateToProps, {
  ticketAssociatedWithSession,
  deleteTicket,
  editTicket,
  showError,
  showSuccess,
  openTicketModal,
  openTicketUrl,
  checkTicketDaschoardStatus,
  openSessionModal,
})(TicketListItem);
